import React from "react";
import { Instagram } from "lucide-react";
import { SOCIALS } from "../mock";

const cards = [
  {
    key: "kick",
    name: "KICK",
    sub: "Watch my streams",
    href: SOCIALS.kick,
    logo: "/assets/kick-green.png",
    titleClass: "text-[#53fc18]",
    glow: "bg-[#53fc18]/25",
    btn: "FOLLOW ME",
    btnClass: "bg-[#53fc18] hover:bg-[#63ff2e] text-[#0e1b0a]",
  },
  {
    key: "discord",
    name: "DISCORD",
    sub: "Chat with us",
    href: SOCIALS.discord,
    logo: "/assets/discord-blurple.png",
    titleClass: "text-[#8b93f8]",
    glow: "bg-[#5865F2]/30",
    btn: "JOIN US",
    btnClass: "bg-[#5865F2] hover:bg-[#6b77f5] text-white",
  },
  {
    key: "x",
    name: "X",
    sub: "Latest updates",
    href: SOCIALS.x,
    logo: "/assets/x-white.png",
    titleClass: "text-white",
    glow: "bg-white/10",
    btn: "FOLLOW ME",
    btnClass: "bg-[#1d1d1f] hover:bg-[#2c2c2f] text-white border border-[#3a3a40]",
  },
  {
    key: "instagram",
    name: "INSTAGRAM",
    sub: "Behind the scenes",
    href: SOCIALS.instagram,
    icon: Instagram,
    titleClass: "text-[#e1619c]",
    glow: "bg-[#E1306C]/25",
    btn: "FOLLOW ME",
    btnClass: "bg-[#E1306C] hover:bg-[#ec4786] text-white",
  },
];

const Socials = () => {
  return (
    <section id="socials" className="relative py-24 px-5 bg-[#2f2753]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-[#edbb23] font-extrabold tracking-[0.3em] text-sm mb-3">COMMUNITY</p>
          <h2 className="text-4xl md:text-5xl font-black text-white">Join The Broer Family</h2>
          <p className="mt-4 text-[#b7b0d6] max-w-xl mx-auto">
            Follow along everywhere and never miss a stream, drop or giveaway.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-6 max-w-5xl mx-auto">
          {cards.map((c) => {
            const Icon = c.icon;
            return (
              <a
                key={c.key}
                href={c.href}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex flex-col items-center text-center"
              >
                <div className="relative mb-6 flex items-center justify-center h-28 sm:h-32">
                  <div className={`absolute w-28 sm:w-32 h-28 sm:h-32 rounded-full blur-2xl ${c.glow} transition-opacity duration-300 opacity-70 group-hover:opacity-100`} />
                  {Icon ? (
                    <Icon size={78} className="relative text-white" strokeWidth={1.6} />
                  ) : (
                    <img
                      src={c.logo}
                      alt={c.name}
                      className="relative h-20 sm:h-24 w-20 sm:w-24 object-contain drop-shadow-2xl transition-transform duration-300 group-hover:-translate-y-2 group-hover:scale-105"
                    />
                  )}
                </div>

                <h3 className={`text-3xl md:text-4xl font-black tracking-tight ${c.titleClass}`}>{c.name}</h3>
                <p className="mt-2 text-[#b7b0d6] text-sm">{c.sub}</p>

                <span
                  className={`mt-6 w-full max-w-[200px] inline-flex items-center justify-center rounded-xl h-12 font-extrabold tracking-wide transition-all duration-300 ${c.btnClass} group-hover:-translate-y-0.5`}
                >
                  {c.btn}
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Socials;
